import MusicInstrumentsUnitHtml from './templates/unit.music-instruments.html';

export function MusicInstrumentsUnits () {
  return {
    //controller: 'VehicleInvoicesCtrl',
    restrict: 'E',
    templateUrl: MusicInstrumentsUnitHtml
  }
}